<template>
  <div class="trending-wrapper">
    <!-- Section Header -->
    <v-row class="px-0 mb-6" no-gutters>
      <v-col cols="12">
        <div class="d-flex align-end justify-space-between section-header-wrap">
          <div class="header-left d-flex flex-column align-start">
            <div class="premium-badge mb-1">
              <v-icon left size="14" color="#3EA56E">mdi-fire</v-icon>
              <span>Trending</span>
            </div>
            <h2 class="professional-title">
              Trending This Week <span class="accent-dot">.</span>
            </h2>
          </div>
          <v-btn text color="#3EA56E" class="view-all-btn px-0 hidden-xs-only" @click="$router.push('/products')">
            Explore All <v-icon right size="18">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Professional Slider -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-carousel
          cycle
          hide-delimiter-background
          :show-arrows="false"
          :height="sliderHeight"
          class="trending-slider-modern"
          delimiter-icon="mdi-circle-medium"
        >
          <v-carousel-item v-for="(slide, i) in photos" :key="i">
            <v-card flat tile :href="slide.link" class="fill-height slider-interactive">
              <v-img
                :src="mediaURLOld + slide.image"
                :height="sliderHeight"
                class="trending-slide-img"
                cover
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular
                      indeterminate
                      color="#3EA56E"
                      size="40"
                    ></v-progress-circular>
                  </v-row>
                </template>
                <!-- Modern Gradient Overlay -->
                <v-overlay absolute opacity="0.1" class="slide-overlay-gradient"></v-overlay>
              </v-img>
            </v-card>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      photos: [],
      appLoading: false,
    };
  },
  beforeMount() {
    this.getData();
  },
  computed: {
    sliderHeight() {
      let height = "350px";
      if (this.$vuetify.breakpoint.xl) height = "400px";
      if (this.$vuetify.breakpoint.lg) height = "300px";
      if (this.$vuetify.breakpoint.md) height = "250px";
      if (this.$vuetify.breakpoint.sm) height = "180px";
      if (this.$vuetify.breakpoint.xs) height = "120px";
      return height;
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/home/slider/getlist",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: { ismiddle: true },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.photos = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.trending-wrapper {
  margin: 60px 0;
}

.section-header-wrap {
  border-bottom: 2px solid #f1f5f9;
  padding-bottom: 12px;
}

.premium-badge {
  display: inline-flex;
  align-items: center;
  background: #f0fdf4;
  padding: 4px 12px;
  border-radius: 20px;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #166534;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.professional-title {
  font-family: 'Poppins', sans-serif;
  font-size: 28px;
  font-weight: 800;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.5px;
}

.accent-dot {
  color: #3EA56E;
}

.view-all-btn {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0.5px;
  font-size: 15px;
}

.view-all-btn:hover {
  background: transparent !important;
}

/* Slider Customization */
.trending-slider-modern {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 15px 45px rgba(0,0,0,0.08) !important;
}

.trending-slide-img {
  transition: transform 0.6s ease-out;
}

.slider-interactive:hover .trending-slide-img {
  transform: scale(1.03);
}

.slide-overlay-gradient {
  background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.2));
}

/* Nav Overrides */
.trending-slider-modern ::v-deep .v-window__prev,
.trending-slider-modern ::v-deep .v-window__next {
  background: white !important;
  color: #1e293b !important;
  width: 44px;
  height: 44px;
  margin: 0 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}

.trending-slider-modern ::v-deep .v-window__prev:hover,
.trending-slider-modern ::v-deep .v-window__next:hover {
  background: #3EA56E !important;
  color: white !important;
}

.trending-slider-modern ::v-deep .v-carousel__controls__item .v-icon {
  color: #cbd5e1 !important;
  opacity: 0.5;
}

.trending-slider-modern ::v-deep .v-carousel__controls__item.v-btn--active .v-icon {
  color: #3EA56E !important;
  opacity: 1;
  transform: scale(1.4);
}

@media (max-width: 600px) {
  .trending-wrapper { margin: 30px 0; }
  .trending-title { font-size: 18px; }
  .trending-subtitle { font-size: 12px; }
  .trending-slider-modern { border-radius: 12px !important; }
}
</style>
